import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Mtrwc { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ""; 
  
    @MaxLength(10) 
    CREATOR: string = ""; 
  
    @MaxLength(10) 
    USR_GROUP: string = ""; 
  
    @MaxLength(8) 
    CREATE_DATE: string =""; 
  
    @MaxLength(10) 
    MODIFIER: string = ""; 
  
    @MaxLength(8) 
    MODI_DATE: string = ""; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 


    @IsNotEmpty({message: '單別 (WC001) 不可空白'}) 
    @MaxLength(4,{message: '單別 (WC001) 資料太長'})
    WC001: string = '';            // 單別 4 

    @IsNotEmpty({message: '單號 (WC002) 不可空白'}) 
    @MaxLength(11,{message: '單號 (WC002) 資料太長'})
    WC002: string = '';            // 單號 11 

    @IsNotEmpty({message: '序號 (WC003) 不可空白'}) 
    @MaxLength(4,{message: '序號 (WC003) 資料太長'})
    WC003: string = '';            // 序號 4 

    @IsNotEmpty({message: '日期 (WC004) 不可空白'}) 
    @MaxLength(8,{message: '日期 (WC004) 資料太長'})
    WC004: string = '';            // 日期 8 

    @IsNotEmpty({message: '問題敘述說明 (WC005) 不可空白'}) 
    @MaxLength(1000,{message: '問題敘述說明 (WC005) 資料太長'})
    WC005: string = '';            // 問題敘述說明 1000 

    @MaxLength(500,{message: '處理說明 (WC006) 資料太長'})
    WC006: string = '';            // 處理說明 500 


}
